export default "__VITE_ASSET__DoSjnmDq__"